module.exports = __webpack_public_path__ + "static/media/pattern-3.a5919cc9.png";